import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: Record<string, unknown>) => void;
          renderButton: (el: HTMLElement, config: Record<string, unknown>) => void;
        };
      };
    };
  }
}

export default function LoginPage() {
  const btnRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { refresh, user } = useAuth();

  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  useEffect(() => {
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
    if (!clientId || !btnRef.current || !window.google) return;

    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: async (response: { credential: string }) => {
        try {
          await api.authGoogle(response.credential);
          await refresh();
          navigate('/');
        } catch (err: unknown) {
          const e = err as Error & { data?: { code?: string } };
          if (e.data?.code === 'NOT_ALLOWLISTED') navigate('/access-denied');
        }
      },
    });
    window.google.accounts.id.renderButton(btnRef.current, {
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
    });
  }, [navigate, refresh]);

  return (
    <div className="login-page">
      <div className="login-card card">
        <img className="login-logo" src="/logo.png" alt="Lion Studios" />
        <h1>Lion Canvas</h1>
        <p className="muted">Sign in with your Lion Studios Google account.</p>
        <div ref={btnRef} className="google-btn" />
        {!import.meta.env.VITE_GOOGLE_CLIENT_ID && (
          <p className="error">Set VITE_GOOGLE_CLIENT_ID for local development.</p>
        )}
      </div>
    </div>
  );
}
